// extracted by mini-css-extract-plugin
export default {"containsTaskList":"containsTaskList_mC6p"};